import React, { Suspense } from 'react';
import './App.css';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import '../src/components/utils/loading/loading.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Modal } from 'react-bootstrap';

const Navbar = React.lazy(() => import('./components/navbar/navbar'));
const Access = React.lazy(() => import('./components/access/access'));
const Support = React.lazy(() => import('./pages/support/support'));

function App() {

  return (<>
    <Router>
      <Suspense fallback={<div>
        <Modal
                    className="modal-container modal-loading"
                    show={true}
                    backdrop="static"
                    keyboard={false}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Body>
                        <div className="d-flex justify-content-center spinner">
                            <span className="icon-spinner">
                                <FontAwesomeIcon icon={faSpinner} />
                            </span>
                        </div>
                        <div className="row text-center">
                            <span className="loading-text">Cargando</span>
                            <small>Por favor espere mientras se procesa la información</small>
                        </div>
                    </Modal.Body>
                </Modal>
        </div>}>
        <Switch>
          <Route path="/" exact component={Navbar} />
          <Route path="/login" exact component={Access} />
          <Route path="/support" exact component={Support} />
          <Redirect to="/" />
        </Switch>
      </Suspense>
    </Router>
  </>);
}

export default App;
